import styled from '@emotion/styled'
import { H2, Text } from 'library/atoms/Typography'
import useTranslation from 'next-translate/useTranslation'
import NotifierContent from '../NotifierContent'

const NotifierRestrictedAccess = () => {
  const { t } = useTranslation('common')

  return (
    <NotifierWrapper>
      <StyledNotifierContent staticIcon="warning">
        <H2>{t('restricted-page')}</H2>
        <Text fontStyle="p3" color="secondary" mt={2}>
          {t('you-dont-have-permission')}
        </Text>
      </StyledNotifierContent>
    </NotifierWrapper>
  )
}

export default NotifierRestrictedAccess

export const NotifierWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  margin: 'auto',
  height: '100%',
  maxWidth: theme.contentMaxWidth.sm,
  alignItems: 'center'
}))

const StyledNotifierContent = styled(NotifierContent)(({ theme }) => ({
  boxShadow: theme.shadows[1]
}))
